// extracted by mini-css-extract-plugin
export default {"Users":"Users_Users__Kkf9R","Users__new":"Users_Users__new__QXwCc"};